import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import styles from './RepaymentScheduleModal.module.css';
import messages from './RepaymentScheduleModal.messages';
import { RepaymentScheduleTable } from './RepaymentScheduleTable';
import { RootState } from '@iwProvider/configureStore';

const mapStateToProps = ({
    repaymentScheduleModal
}: {
    repaymentScheduleModal: RootState['repaymentScheduleModal'];
}) => repaymentScheduleModal;

type PropsFromRedux = ReturnType<typeof mapStateToProps>;

const RepaymentScheduleModal = (props: PropsFromRedux) => {
    return (
        <div
            data-testid="repayments-schedule-modal"
            className={styles.RepaymentScheduleModal}
        >
            <div className={styles.title}>
                <FormattedMessage {...messages.title} />
            </div>

            <RepaymentScheduleTable {...props} />
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(RepaymentScheduleModal);
